export const SEARCH_ENGINE_HOSTS = [
  'google',
  'bing',
  'duckduckgo',
  'yahoo',
  'yandex',
  'baidu',
  'ecosia',
  'brave',
  'startpage',
] as const;
